import { SimulationPostprocessingStatus } from "src/clients/jobs";
import { JobRun, JobRunStatusType } from "src/jobs/types";

export const isSimulationSuccessful = (simulation: JobRun) => {
  return (
    simulation.status.type === JobRunStatusType.Completed &&
    simulation.simulation_job_run_details?.post_processing_status ===
      SimulationPostprocessingStatus.COMPLETED
  );
};

export const isSimulationFailed = (jobRun: JobRun) => {
  return (
    jobRun.status.type === JobRunStatusType.Failed ||
    jobRun.simulation_job_run_details?.post_processing_status ===
      SimulationPostprocessingStatus.FAILED
  );
};

export const isSimulationStopped = (jobRun: JobRun) =>
  jobRun.status.type === JobRunStatusType.Stopped;

export const isSimulationInProgress = (jobRun: JobRun) =>
  !isSimulationSuccessful(jobRun) &&
  !isSimulationFailed(jobRun) &&
  !isSimulationStopped(jobRun);

export const isSimulationComplete = (jobRun: JobRun) => {
  return isSimulationSuccessful(jobRun) || isSimulationFailed(jobRun);
};

// Thinking here is that people should not block themselves out of stopping their simulations be hiding them first.
export const canSimulationBeDeleted = (jobRun: JobRun) =>
  !simulationCanBeStopped(jobRun);

export const simulationCanBeStopped = (jobRun: JobRun) =>
  jobRun.status.type === JobRunStatusType.Running ||
  jobRun.status.type === JobRunStatusType.Writing;
